import { render, staticRenderFns } from "./UploadImportacaoModal.vue?vue&type=template&id=a5788494&scoped=true"
import script from "./UploadImportacaoModal.vue?vue&type=script&lang=js"
export * from "./UploadImportacaoModal.vue?vue&type=script&lang=js"
import style0 from "./UploadImportacaoModal.vue?vue&type=style&index=0&id=a5788494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5788494",
  null
  
)

export default component.exports